import { render, staticRenderFns } from "./chat-request-user-list.html?vue&type=template&id=ef1fe374&scoped=true&"
import script from "./chat-request-user-list.js?vue&type=script&lang=js&"
export * from "./chat-request-user-list.js?vue&type=script&lang=js&"
import style0 from "./chat-request-user-list.scss?vue&type=style&index=0&id=ef1fe374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1fe374",
  null
  
)

export default component.exports